<script setup>

import {computed, onMounted, ref} from "vue";
import {_mft} from "../../../i18n";

const stripeValidated = ref(false)
const stripeActive = ref(false)
const stripePublicKey = ref('')
const stripeSecretKey = ref('')
const useStripeAutoTax = ref(false)

const updateSettingsState = ref('')
const displaySecret = ref(false)

const loadSettings = async () => {
    const res = await axios.get(route('settings.company.stripe.get'))

    if (res.data.success) {
        stripeValidated.value = res.data.stripe_validated
        stripeActive.value = res.data.stripe_active
        stripePublicKey.value = res.data.stripe_public_key
        stripeSecretKey.value = res.data.stripe_secret_key
        useStripeAutoTax.value = res.data.use_stripe_auto_tax
    }
}

const updateSettings = async () => {
    if (!validates || updateSettingsState.value === 'working') {
        return
    }


    updateSettingsState.value = 'working'

    const res = await axios.post(route('settings.company.settings.update'), {
            stripe_active: stripeActive.value,
            stripe_public_key: stripePublicKey.value,
            stripe_secret_key: stripeSecretKey.value,
            use_stripe_auto_tax: useStripeAutoTax.value
        }
    )

    if (res.data.success) {
        updateSettingsState.value = 'success'
    } else {
        updateSettingsState.value = 'error'
    }
}

const publicKeyValidationMessage = computed(() => {
    if (stripePublicKey.value && stripePublicKey.value.length > 0 && !stripePublicKey.value.startsWith('pk_live')) {
        return _mft('setting:payment.stripe.publicKeyWarning')
    }
    return null
})

const secretKeyValidationMessage = computed(() => {
    if (stripeSecretKey.value && stripeSecretKey.value.length > 0 && !stripeSecretKey.value.startsWith('sk_live')) {
        return _mft('setting:payment.stripe.secretKeyWarning')
    }
    return null
})

const validates = computed(() => {
    return !publicKeyValidationMessage.value  && !secretKeyValidationMessage.value
})

onMounted(() => {
    loadSettings()
})

</script>
<template>
    <div>
        <h5>{{ _mft('setting:payment.stripe.cardPayments') }}</h5>

        <toggle-switch
            name="stripe_active"
            label="shared:enabled"
            v-model:content="stripeActive"
        ></toggle-switch>

        <div
            v-if="stripeValidated"
            class="mb-4"
        >
            <toggle-switch
                :label="_mft('setting:invoicing.useAutomaticStripeTax')"
                v-model:content="useStripeAutoTax"
            ></toggle-switch>
            <div
                v-if="useStripeAutoTax"
                class="text-xs text-gray-500 -mt-3"
            >
                <i class="fa-solid fa-triangle-exclamation text-myflowYellow"></i>
                {{ _mft('setting:invoicing.useAutomaticStripeTax.stripeSettingReminder') }}
            </div>
            <a class="mf-link text-xs" :href="route('redirect-stripe-tax')" target="_blank">Stripe Tax Settings <i class="fa-regular fa-arrow-up-right-from-square text-xs ml-1"></i></a>
        </div>

        <hr class="mt-8 mb-6">

        <input-text
            v-model:content="stripePublicKey"
            label="Stripe Public Key"
            name="stripe_public_key"
            class="!mb-0"
        ></input-text>
        <p v-if="publicKeyValidationMessage" class="text-xs text-myflowRed font-semibold">
            {{ publicKeyValidationMessage }}
        </p>

        <input-label
            class="mt-3"
            label="Stripe Secret Key"
        ></input-label>
        <div class="flex items-center space-x-2">
            <input-text
                v-model:content="stripeSecretKey"
                name="stripe_secret_key"
                :inputtype="displaySecret ? 'text' : 'password'"
                class="!mb-0 w-full"
            ></input-text>
            <button-secondary
                @click="displaySecret = !displaySecret"
                class="w-12 justify-center"
            >
                <i class="fa-regular fa-eye" v-if="!displaySecret"></i>
                <i class="fa-regular fa-eye-slash" v-if="displaySecret"></i>
            </button-secondary>
        </div>
        <p v-if="secretKeyValidationMessage" class="text-xs text-myflowRed font-semibold">
            {{ secretKeyValidationMessage }}
        </p>

        <card-sub
            v-if="stripeValidated"
            class="font-semibold text-myflowGreen-900 bg-green-100 my-4"
        >
            {{ _mft('setting:payment.stripe.hasBeenValidated') }}
        </card-sub>

        <div class="flex justify-end mt-3">
            <button-success
                :disabled="!validates"
                @click="updateSettings"
                :state="updateSettingsState"
            >
                {{ _mft('shared:action.save') }}
            </button-success>
        </div>
    </div>
</template>
